export default "__VITE_ASSET__D3ZrY7SM__"